import React, { useState, useEffect } from 'react'
import { Input, Button, DatePicker, Popup, Dialog, WaterMark, SafeArea, Toast, NavBar } from 'antd-mobile'
import { useNavigate } from "react-router-dom";
import * as api from '../../services/api';
import { useOKRequest } from '../../hooks';
import { getAuth } from '../../modules/auth';
import './addPatient.css';

function AddPatient() {
  const navigate = useNavigate();

  const now = new Date()
  const [no, setNo] = useState('')
  const [name, setName] = useState('')
  const [sex, setSex] = useState('')
  const [birthday, setBirthday] = useState('')
  const [phone, setPhone] = useState('')
  const [remark, setRemark] = useState('')
  const [mode, setMode] = useState('')
  const [trainTime, setTrainTime] = useState('')
  const [visibleDate, setVisibleDate] = useState(false) // 日期选择弹窗
  const [visibleSex, setVisibleSex] = useState(false) // 性别选择弹窗
  const [visibleType, setVisibleType] = useState(false) // 弱视眼别选择弹窗
  const [errors, setErrors] = useState({ no: false, name: false, sex: false, birthday: false, phone: false, mode: false, trainTime: false });

  // 添加患者基础信息接口
  const { loading: loading, run: insertPatientBase } = useOKRequest(api.insertPatientBase, {
    manual: true,
    onSuccess: (res) => {
      if (res.data.code === 200) {
        // Toast.show({
        //   content: '添加成功',
        // })
        // navigate('/patientList')
        const params = {
          no: res?.data?.result?.no,
          mode: mode === '左眼弱视' ? '3' : mode === '右眼弱视' ? '4' : 5,
          trainTime,
        }
        updatePatientModeByNo(params)
      } else {
        Toast.show({
          content: res.data.message,
        })
      }
    },
  });

  // 更新患者训练信息接口
  const { loading: loading1, run: updatePatientModeByNo } = useOKRequest(api.updatePatientModeByNo, {
    manual: true,
    onSuccess: (res) => {
      if (res.data.code === 200) {
        Toast.show({
          content: '添加成功',
        })
        navigate('/patientList')
      } else {
        Toast.show({
          content: res.data.message,
        })
      }
    },
  });

  // 日期转换
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以需要加1
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  const showDialog = (message) => {
    Dialog.show({
      content: <div className='AddPatient_errorTip'>{message}</div>,
      closeOnAction: true,
      actions: [
        [
          {
            key: 'cancel',
            text: <div className='AddPatient_action'>确定</div>,
          },
        ],
      ],
    });
  };

  // 校验手机号
  const validatePhoneNumber = (phoneNumber) => {
    // 定义手机号码的正则表达式
    const regex = /^1[3-9]\d{9}$/;
    // 使用正则表达式测试手机号码
    if (regex.test(phoneNumber)) {
      return true; // 手机号码格式正确
    } else {
      return false; // 手机号码格式错误
    }
  }

  const handleInputChange = (name, value) => {
    if (name === 'no') setNo(value);
    if (name === 'name') setName(value);
    if (name === 'sex') setSex(value);
    if (name === 'birthday') setBirthday(value);
    if (name === 'phone') setPhone(value);
    if (name === 'mode') setMode(value);
    // if (name === 'trainTime') setTrainTime(value);
    if (name === 'trainTime') {
      // 使用正则表达式去除小数点
      const filteredValue = value.replace(/[^\d]/g, '');
      // 设置输入框的值为过滤后的内容
      setTrainTime(filteredValue);
    };
    // 输入值时清除错误状态，清空值时添加错误信息
    if (value) {
      setErrors(prevErrors => ({
        ...prevErrors,
        [name]: false,
      }));
      // if (name === 'trainTime' && (Number(value) < 1 || Number(value) > 1440)) {
      //   setErrors(prevErrors => ({
      //     ...prevErrors,
      //     [trainTime]: true,
      //   }));
      // } else {
      //   setErrors(prevErrors => ({
      //     ...prevErrors,
      //     [name]: false,
      //   }));
      // }
    } else {
      setErrors(prevErrors => ({
        ...prevErrors,
        [name]: true,
      }));
    }
  };

  const onsubmit = async () => {
    // 检测参数是否为空
    const newErrors = {
      no: !no, name: !name, sex: !sex, birthday: !birthday, 
      // phone: !phone, 
      phone: !validatePhoneNumber(phone) ? true : !phone, 
      mode: !mode,
      trainTime: !trainTime
      // trainTime: Number(trainTime) < 1 || Number(trainTime) > 1440 ? true : !trainTime
    };
    // 更新错误状态
    setErrors(newErrors);
    // console.log('Errors', errors)
    if (!no) {
      showDialog('请输入患者编号');
      return;
    }
    if (!name) {
      showDialog('请输入患者姓名');
      return;
    }
    if (!sex) {
      showDialog('请选择患者性别');
      return;
    }
    if (!birthday) {
      showDialog('请选择出生日期');
      return;
    }
    if (!phone) {
      showDialog('请输入联系方式');
      return;
    }
    if (!validatePhoneNumber(phone)) {
      showDialog('联系方式手机号格式错误');
      return;
    }
    if (!mode) {
      showDialog('请选择弱视眼别');
      return;
    }
    if (!trainTime) {
      showDialog('请输入训练时长');
      return;
    }
    // if ((Number(trainTime) < 1 || Number(trainTime) > 1440)) {
    //   showDialog('请输入正确范围的数字');
    //   return;
    // }
    // const params = { no, name, sex, birthday, phone, remark, mode, trainTime }
    const params = {
      no, name, sex, birthday, phone, remark,
      createBy: getAuth()?.username,
      sysDepartId: getAuth()?.departIds
    }
    console.log('params', params)
    insertPatientBase(params)
  }

  return (
    <div className='AddPatient'>
      <NavBar
        // back='添加患者'
        onBack={() => navigate(-1)}>
        添加患者
      </NavBar>
      <WaterMark fontColor='rgba(0, 0, 0, .1)' content={[getAuth()?.depart_name, getAuth()?.realname]} />
      <div className="AddPatient_title">基本信息</div>
      <div className="AddPatient_baseInfo">
        <div className="AddPatient_formItem">
          <div className="AddPatient_itemText">
            <div className='AddPatient_itemIcon'>*</div>
            <div>患者编号</div>
          </div>
          <Input
            className={`AddPatient_formInput ${errors.no ? 'error-border' : ''}`}
            style={{ padding: '0 16px' }}
            placeholder='点击输入文本'
            clearable
            value={no}
            // onChange={val => {
            //   setNo(val)
            // }}
            onChange={val => handleInputChange('no', val)}
          />
        </div>
        <div className="AddPatient_formItem">
          <div className="AddPatient_itemText">
            <div className='AddPatient_itemIcon'>*</div>
            <div>患者姓名</div>
          </div>
          <Input
            className={`AddPatient_formInput ${errors.name ? 'error-border' : ''}`}
            style={{ padding: '0 16px' }}
            placeholder='点击输入文本'
            clearable
            value={name}
            // onChange={val => {
            //   setName(val)
            // }}
            onChange={val => handleInputChange('name', val)}
          />
        </div>
        <div className="AddPatient_formItem">
          <div className="AddPatient_itemText">
            <div className='AddPatient_itemIcon'>*</div>
            <div>患者性别</div>
          </div>
          <div
            className={`AddPatient_DatePicker ${errors.sex ? 'error-border' : ''}`}
            onClick={() => {
              setVisibleSex(true)
            }}
          >
            <Input
              className='input'
              style={{ padding: '0 16px' }}
              placeholder='请选择'
              value={sex}
              readOnly
            />
            <div className='dateIcon'>
              <img
                src="./images/pull.png"
                alt=""
              />
            </div>
          </div>
          <Popup
            visible={visibleSex}
            // onMaskClick={() => {
            //   setVisibleSex(false)
            // }}
            bodyStyle={{
              borderTopLeftRadius: '8px',
              borderTopRightRadius: '8px',
              minHeight: '20vh',
            }}
          >
            <Button
              block
              className="AddPatient_formSexItem"
              onClick={() => {
                // setSex('男')
                handleInputChange('sex', '男')
                setVisibleSex(false)
              }}
            >男</Button>
            <div className="AddPatient_divider"></div>
            <Button
              block
              className="AddPatient_formSexItem"
              onClick={() => {
                // setSex('女')
                handleInputChange('sex', '女')
                setVisibleSex(false)
              }}
            >女</Button>
            <div className="AddPatient_divider1"></div>
            <Button
              block
              className="AddPatient_formSexItem"
              onClick={() => {
                setVisibleSex(false)
              }}
            >取消</Button>
          </Popup>
        </div>
        <div className="AddPatient_formItem">
          <div className="AddPatient_itemText">
            <div className='AddPatient_itemIcon'>*</div>
            <div>出生日期</div>
          </div>
          <div
            className={`AddPatient_DatePicker ${errors.birthday ? 'error-border' : ''}`}
            onClick={() => {
              setVisibleDate(true)
            }}
          >
            <Input
              className='input'
              style={{ padding: '0 16px' }}
              placeholder='选择日期'
              value={birthday}
              readOnly
            />
            <div className='dateIcon'>
              <img
                src="./images/date.png"
                alt=""
              />
            </div>
          </div>
          <DatePicker
            title='选择日期'
            visible={visibleDate}
            onClose={() => {
              setVisibleDate(false)
            }}
            closeOnMaskClick={false}
            min={new Date('1900-01-01')}
            max={now}
            onConfirm={val => {
              console.log('val', formatDate(val))
              // setBirthday(formatDate(val))
              handleInputChange('birthday', formatDate(val))
            }}
          />
        </div>
        <div className="AddPatient_formItem">
          <div className="AddPatient_itemText">
            <div className='AddPatient_itemIcon'>*</div>
            <div>联系方式</div>
          </div>
          <Input
            className={`AddPatient_formInput ${errors.phone ? 'error-border' : ''}`}
            style={{ padding: '0 16px' }}
            placeholder='输入手机号码'
            clearable
            value={phone}
            // onChange={val => {
            //   setPhone(val)
            // }}
            onChange={val => handleInputChange('phone', val)}
          />
        </div>
        <div className="AddPatient_formItem">
          <div className="AddPatient_itemText">
            备注信息
          </div>
          <Input
            className='AddPatient_formInput'
            style={{ padding: '0 16px' }}
            placeholder='点击输入文本'
            clearable
            value={remark}
            onChange={val => {
              setRemark(val)
            }}
          />
        </div>
      </div>
      <div className="AddPatient_title">训练信息</div>
      <div className="AddPatient_trainInfo">
        <div className="AddPatient_formItem">
          <div className="AddPatient_itemText">
            <div className='AddPatient_itemIcon'>*</div>
            <div>弱视眼别</div>
          </div>
          <div
            className={`AddPatient_DatePicker ${errors.mode ? 'error-border' : ''}`}
            onClick={() => {
              setVisibleType(true)
            }}
          >
            <Input
              className='input'
              style={{ padding: '0 16px' }}
              placeholder='请选择'
              value={mode}
              readOnly
            />
            <div className='dateIcon'>
              <img
                src="./images/pull.png"
                alt=""
              />
            </div>
          </div>
          <Popup
            visible={visibleType}
            bodyStyle={{
              borderTopLeftRadius: '8px',
              borderTopRightRadius: '8px',
              // minHeight: '20vh',
            }}
          >
            <Button
              block
              className="AddPatient_formSexItem"
              onClick={() => {
                handleInputChange('mode', '左眼弱视')
                setVisibleType(false)
              }}
            >左眼弱视</Button>
            <div className="AddPatient_divider"></div>
            <Button
              block
              className="AddPatient_formSexItem"
              onClick={() => {
                handleInputChange('mode', '右眼弱视')
                setVisibleType(false)
              }}
            >右眼弱视</Button>
            <div className="AddPatient_divider"></div>
            <Button
              block
              className="AddPatient_formSexItem"
              onClick={() => {
                handleInputChange('mode', '双眼弱视')
                setVisibleType(false)
              }}
            >双眼弱视</Button>
            <div className="AddPatient_divider1"></div>
            <Button
              block
              className="AddPatient_formSexItem"
              onClick={() => {
                setVisibleType(false)
              }}
            >取消</Button>
          </Popup>
        </div>
        <div className="AddPatient_formItem">
          <div className="AddPatient_itemText">
            <div className='AddPatient_itemIcon'>*</div>
            <div>每日训练时长（分钟）</div>
          </div>
          <Input
            className={`AddPatient_formInput ${errors.trainTime ? 'error-border' : ''}`}
            style={{ padding: '0 16px' }}
            placeholder='输入1-1440范围内的数字'
            clearable
            value={trainTime}
            onChange={val => handleInputChange('trainTime', val)}
            type='number'
            min={1}
            max={1440}
          />
        </div>
      </div>
      <div style={{ paddingBottom: '68px' }}>
        <Button
          className='AddPatient_btn'
          block
          loading={loading || loading1}
          onClick={onsubmit}
        >
          完成添加
        </Button>
      </div>
      <SafeArea position='bottom' />
    </div>
  );
}

export default AddPatient;